import { Paragraph, Spacing } from "@sicredi/react";
import { CardTracking } from "../CardTracking";
import { ITrackingComponents } from "../model";

export const ConsorcioContratadoTracking: React.FC<ITrackingComponents> = ({
  state,
  isIconClock,
  paragraphSize,
  grupo,
  cota,
}) => {
  return (
    <CardTracking
      title="Consórcio contratado"
      state={state}
      isIconClock={isIconClock}
    >
      {state && (
        <Paragraph size={paragraphSize(state)} weight="normal">
          <strong>Grupo:</strong> {grupo}
          <br />
          <strong>Cota:</strong> {cota}
        </Paragraph>
      )}
      {!state && <Spacing appearance="x-large" />}
    </CardTracking>
  );
};
